import { useEffect, useState } from "react";

/**
 * One breakpoint for the whole filter.
 *
 * The bar and the panel used to decide "am I small?" separately — 767px for the
 * drawer presentation, 1023px for the panel layout. Between those two widths
 * you got a desktop side-drawer wrapped around compact content, which is the
 * "still behaves like a PC" case. They share this now.
 *
 * Matches Tailwind's `lg`, so `lg:` utilities and this hook always agree.
 */
export const COMPACT_QUERY = "(max-width: 1023px)";

export default function useCompactLayout(): boolean {
  const [compact, setCompact] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(COMPACT_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const query = window.matchMedia(COMPACT_QUERY);
    const handler = (event: MediaQueryListEvent) => setCompact(event.matches);
    // re-read on mount: the match can differ from the initial render after
    // hydration, an orientation change, or a devtools viewport switch
    setCompact(query.matches);
    query.addEventListener("change", handler);
    return () => query.removeEventListener("change", handler);
  }, []);

  return compact;
}
